var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45455 3.13636C6.45455 2.78491 6.16964 2.5 5.81818 2.5C5.46673 2.5 5.18182 2.78491 5.18182 3.13636V3.98484H3.90909C2.85473 3.98484 2 4.83957 2 5.89393V13.9545C2 15.0089 2.85473 15.8636 3.90909 15.8636H14.0909C15.1453 15.8636 16 15.0089 16 13.9545V5.89393C16 4.83957 15.1453 3.98484 14.0909 3.98484H12.8182V3.13636C12.8182 2.78491 12.5333 2.5 12.1818 2.5C11.8304 2.5 11.5455 2.78491 11.5455 3.13636V3.98484H6.45455V3.13636ZM3.27273 13.9545V8.01516H14.7273V13.9545C14.7273 14.306 14.4424 14.5909 14.0909 14.5909H3.90909C3.55764 14.5909 3.27273 14.306 3.27273 13.9545ZM5.43637 9.71213C5.06148 9.71213 4.75758 10.016 4.75758 10.3909V12.4273C4.75758 12.8022 5.06148 13.1061 5.43637 13.1061H7.47273C7.84762 13.1061 8.15152 12.8022 8.15152 12.4273V10.3909C8.15152 10.016 7.84762 9.71213 7.47273 9.71213H5.43637Z",
    fill: "#1FA37C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.c5bae227d5d0435c086f3ef0a63a47ba.svg";
export { ForwardRef as ReactComponent };